import ChunkBase from './ChunkBase';
import PlatformContainer from './PlatformContainer';
import PlatformImage from './platforms/PlatformImage';
import PlatformCollapsedPillarNormal from './platforms/cave/PlatformCollapsedPillarNormal';
import PlatformCollapsedPillarShort from './platforms/cave/PlatformCollapsedPillarShort';
import PlatformStack1 from './platforms/cave/PlatformStack1';
import PlatformStack2 from './platforms/cave/PlatformStack2';
import PlatformStack3 from './platforms/cave/PlatformStack3';
import PlatformPillar from './platforms/cave/PlatformPillar';
import PlatformGroundLava from './platforms/cave/PlatformGroundLava';
import PlatformRock from './platforms/cave/PlatformRock';
import EditorPlatformMarker from './EditorPlatformMarker';
import PlatformMarkerBarrel from './editor/platform-markers/shipwreck/PlatformMarkerBarrel';
import PlatformBarrel from './platforms/shipwreck/PlatformBarrel';
import PlatformLog from './platforms/shipwreck/PlatformLog';
import PlatformLogLong from './platforms/shipwreck/PlatformLogLong';
import PlatformLogMid from './platforms/shipwreck/PlatformLogMid';
import PlatformSubmergedBarrel from './platforms/shipwreck/PlatformSubmergedBarrel';
import PlatformLogKnot from './platforms/shipwreck/PlatformLogKnot';
import PlatformCabin from './platforms/shipwreck/PlatformCabin';
import PlatformPole from './platforms/shipwreck/PlatformPole';
import PlatformFoliage1 from './platforms/jungle/PlatformFoliage1';
import PlatformFoliage2 from './platforms/jungle/PlatformFoliage2';
import PlatformFoliage3 from './platforms/jungle/PlatformFoliage3';
import PlatformFoliage4 from './platforms/jungle/PlatformFoliage4';
import PlatformJungleLog from './platforms/jungle/PlatformJungleLog';
import PlatformJungleLogLong from './platforms/jungle/PlatformJungleLogLong';
import PlatformJungleLogMid from './platforms/jungle/PlatformJungleLogMid';
import PlatformJungleLogKnot from './platforms/jungle/PlatformJungleLogKnot';
import PlatformPlatMini from './platforms/cave/PlatformPlatMini';
import PlatformPlat from './platforms/cave/PlatformPlat';
import PlatformPlatMid from './platforms/cave/PlatformPlatMid';
import PlatformPlatLong from './platforms/cave/PlatformPlatLong';
import SimpleMover from './../components/platformer/SimpleMover';
import MoverData from './../components/platformer/MoverData';
import PlatformMarkerLog from './editor/platform-markers/shipwreck/PlatformMarkerLog';
import PlatformMarkerLogLong from './editor/platform-markers/shipwreck/PlatformMarkerLogLong';
import PlatformMarkerLogMid from './editor/platform-markers/shipwreck/PlatformMarkerLogMid';
import PlatformMarkerLogKnot from './editor/platform-markers/shipwreck/PlatformMarkerLogKnot';
import PlatformMarkerSubmergedBarrel from './editor/platform-markers/shipwreck/PlatformMarkerSubmergedBarrel';
import PlatformMarkerCabin from './editor/platform-markers/shipwreck/PlatformMarkerCabin';
import PlatformMarkerPole from './editor/platform-markers/shipwreck/PlatformMarkerPole';
import PlatformMarkerFoliage1 from './editor/platform-markers/jungle/PlatformMarkerFoliage1';
import PlatformMarkerFoliage2 from './editor/platform-markers/jungle/PlatformMarkerFoliage2';
import PlatformMarkerFoliage3 from './editor/platform-markers/jungle/PlatformMarkerFoliage3';
import PlatformMarkerFoliage4 from './editor/platform-markers/jungle/PlatformMarkerFoliage4';
import PlatformMarkerJungleLog from './editor/platform-markers/jungle/PlatformMarkerJungleLog';
import PlatformMarkerJungleLogLong from './editor/platform-markers/jungle/PlatformMarkerJungleLogLong';
import PlatformMarkerJungleLogMid from './editor/platform-markers/jungle/PlatformMarkerJungleLogMid';
import PlatformMarkerJungleLogKnot from './editor/platform-markers/jungle/PlatformMarkerJungleLogKnot';
import PlatformMarkerCollapsedPillarShort from './editor/platform-markers/cave/PlatformMarkerCollapsedPillarShort';
import PlatformMarkerCollapsedPillarNormal from './editor/platform-markers/cave/PlatformMarkerCollapsedPillarNormal';
import PlatformMarkerGroundLava from './editor/platform-markers/cave/PlatformMarkerGroundLava';
import PlatformMarkerRock from './editor/platform-markers/cave/PlatformMarkerRock';
import PlatformMarkerPillar from './editor/platform-markers/cave/PlatformMarkerPillar';
import PlatformMarkerStack1 from './editor/platform-markers/cave/PlatformMarkerStack1';
import PlatformMarkerStack2 from './editor/platform-markers/cave/PlatformMarkerStack2';
import PlatformMarkerStack3 from './editor/platform-markers/cave/PlatformMarkerStack3';
import PlatformMarkerPlatMini from './editor/platform-markers/cave/PlatformMarkerPlatMini';
import PlatformMarkerPlat from './editor/platform-markers/cave/PlatformMarkerPlat';
import PlatformMarkerPlatMid from './editor/platform-markers/cave/PlatformMarkerPlatMid';
import PlatformMarkerPlatLong from './editor/platform-markers/cave/PlatformMarkerPlatLong';
import EditorPlatformMarkerImage from './EditorPlatformMarkerImage';
import PlatformMarkerGroundLavaLong from './editor/platform-markers/cave/PlatformMarkerGroundLavaLong';
import PlatformGroundLavaLong from './platforms/cave/PlatformGroundLavaLong';

type platform = PlatformImage | PlatformContainer;

export class PlatformFactory {
  public static markerToPlatform: Map<typeof EditorPlatformMarkerImage, typeof PlatformImage | typeof PlatformContainer> = new Map([
    // Shipwreck
    [PlatformMarkerLog, PlatformLog],
    [PlatformMarkerLogLong, PlatformLogLong],
    [PlatformMarkerLogMid, PlatformLogMid],
    [PlatformMarkerLogKnot, PlatformLogKnot],
    [PlatformMarkerBarrel, PlatformBarrel],
    [PlatformMarkerSubmergedBarrel, PlatformSubmergedBarrel],
    [PlatformMarkerCabin, PlatformCabin],
    [PlatformMarkerPole, PlatformPole],

    // Jungle
    [PlatformMarkerFoliage1, PlatformFoliage1],
    [PlatformMarkerFoliage2, PlatformFoliage2],
    [PlatformMarkerFoliage3, PlatformFoliage3],
    [PlatformMarkerFoliage4, PlatformFoliage4],
    [PlatformMarkerJungleLog, PlatformJungleLog],
    [PlatformMarkerJungleLogLong, PlatformJungleLogLong],
    [PlatformMarkerJungleLogMid, PlatformJungleLogMid],
    [PlatformMarkerJungleLogKnot, PlatformJungleLogKnot],

    // Cave
    // [PlatformMarkerCollapsedPillarShort, PlatformCollapsedPillarShort],
    [PlatformMarkerCollapsedPillarNormal, PlatformCollapsedPillarNormal],
    [PlatformMarkerGroundLava, PlatformGroundLava],
    [PlatformMarkerGroundLavaLong, PlatformGroundLavaLong],
    [PlatformMarkerRock, PlatformRock],
    [PlatformMarkerPillar, PlatformPillar],
    [PlatformMarkerStack1, PlatformStack1],
    [PlatformMarkerStack2, PlatformStack2],
    [PlatformMarkerStack3, PlatformStack3],
    [PlatformMarkerPlatMini, PlatformPlatMini],
    [PlatformMarkerPlat, PlatformPlat],
    [PlatformMarkerPlatMid, PlatformPlatMid],
    [PlatformMarkerPlatLong, PlatformPlatLong]
  ]);

  protected scene: Phaser.Scene;
  protected isInitialised: boolean;
  protected groups: Map<typeof PlatformImage | typeof PlatformContainer, Phaser.GameObjects.Group>;

  constructor(scene: Phaser.Scene) {
    this.scene = scene;
    this.isInitialised = false;

    this.groups = new Map();
  }

  public init() {
    this.groups = new Map();

    // if (this.isInitialised) return;

    for (const [key, platformClass] of PlatformFactory.markerToPlatform) {
      if (platformClass && !this.groups.has(platformClass)) {
        // console.log('Create group.', platformClass.name);
        let group = this.scene.add.group([], { classType: platformClass });
        for (let i = 0; i < 5; i++) {
          group.create(-1000, 0, undefined, undefined, false, false);
        }
        this.groups.set(platformClass, group);
      }
    }

    // this.isInitialised = true;
  }

  public makePlatform(marker: EditorPlatformMarker, chunk: ChunkBase, x: number, y: number): platform | undefined {
    for (const [key, platformClass] of PlatformFactory.markerToPlatform) {
      if (marker instanceof key) {
        let group = this.groups.get(platformClass) as Phaser.GameObjects.Group;
        let newPlatform = group.get() as platform;
        newPlatform.x = x;
        newPlatform.y = y;
        newPlatform.init();
        newPlatform.bindChunk(chunk);
        newPlatform.reset();

        if (marker instanceof EditorPlatformMarker && marker.isMovingPlatform) {
          let dataMover = MoverData.getComponent(marker);
          let mover = new SimpleMover(newPlatform);
          mover.setFromMoverData(dataMover);
        }

        console.log(`platform ${platformClass.name}  group size post`, group.getLength());
        return newPlatform;
      }
    }
  }
}
